module.exports = __webpack_public_path__ + "img/source_at01.360b65f2.png";